<template>
  <div>
    <b-dropdown position="is-bottom-left" append-to-body aria-role="menu" trap-focus ref="filterRef">
      <b-button
        slot="trigger"
        type="is-info"
        icon-left="filter">
          Filtrar
      </b-button>
      <b-dropdown-item
        aria-role="menu-item"
        :focusable="false"
        custom
        paddingless>
          <form action="">
            <!-- <header class="modal-card-head filter-content-padding">
            </header> -->
            <div class="modal-card" style="width:auto; overflow:visible;">
                <section class="modal-card-body filter-content-padding" style="overflow:visible;">
                    <b-field label="Solo Jinetes Oficiales" expanded>
                        <b-switch v-model="onlyOfficials">
                            {{ onlyOfficials ? 'Si' : 'No' }}
                        </b-switch>
                    </b-field>
                </section>
                <footer class="modal-card-foot filter-content-padding" style="justify-content: center;">
                  <b-button type="is-danger" rounded expanded @click="restart" aria-role="menu-item">Restaurar</b-button>
                  <b-button type="is-primary" rounded expanded @click="apply" aria-role="menu-item">Aplicar</b-button>
                </footer>
            </div>
          </form>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      onlyOfficials: true
    }
  },
  methods: {
    apply () {
      let filters = this.getFilters()
      this.$refs.filterRef.toggle()
      this.$emit('filtered', filters)
    },
    restart () {
      this.onlyOfficials = true
      this.apply()
    },
    getFilters () {
      let filters = {
        'show_no_officials': this.onlyOfficials
      }
      return filters
    }
  },
  computed: {
    riderId () {
      return this.rider ? this.rider.id : null
    }
  }
}
</script>

<style scoped>
  .dropdown-content{
   /* padding-top: 0px !important; */
    padding-bottom: 0px !important;
    -webkit-box-shadow: 0px 4px 9px 2px rgba(0,0,0,0.3);
    -moz-box-shadow: 0px 4px 9px 2px rgba(0,0,0,0.3);
    box-shadow: 0px 4px 9px 2px rgba(0,0,0,0.3);
  }
  .filter-content-padding{
    padding: 10px 15px;
  }

  .is-grouped{
    margin-bottom: 0px !important;
  }

  .select select option:disabled {
    color: #BDBDBD !important;
  }
</style>
